import { EnvironmentType } from '@shared/utils/enums';

import { Environment } from './_common';
import { APP_VERSION } from './version';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://admin-area-hub-api.ctrl-stg.a.broadwayplatform.io/api/v1/public/admin-area-hub',
  apiUrlV2: 'https://admin-area-hub-api.ctrl-stg.a.broadwayplatform.io/api/v2/public/admin-area-hub',
  version: `${APP_VERSION}@${EnvironmentType.Staging}`,
  environment: EnvironmentType.Staging,
  googleClientId: '986838903566-eammrpcalivddust8sjkda9gnti1jqh4.apps.googleusercontent.com',
  googleSiteKey: '6LdX0MsrAAAAAG-vneTCC_RWULLtqafyg-PsQkjp',
};
